import React, { ReactElement } from "react";

export const HypotheekAlgemeenExtraText = (display: string) => (): ReactElement => <h2 className="mt-4">{display}</h2>;

/* istanbul ignore else */ if (process.env.NODE_ENV !== "production")
  HypotheekAlgemeenExtraText.displayName = "HypotheekAlgemeenExtraText";
